import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import { isChrome, isFirefox, isIeEdge } from "@tightrope/lpscripts/browserdetect";
import Styles from "./css/ctadisclosure.module.scss";
let CtaDisclosure = /*#__PURE__*/function (_React$Component) {
  function CtaDisclosure(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      data: {}
    };
    return _this;
  }
  _inheritsLoose(CtaDisclosure, _React$Component);
  var _proto = CtaDisclosure.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.props.data) {
      this.state = {
        data: this.props.data
      };
    }
  };
  _proto.render = function render() {
    let browser = null;
    if (isChrome()) {
      browser = 'chrome';
    } else if (isFirefox()) {
      browser = 'firefox';
    } else {
      browser = 'other';
    }
    return /*#__PURE__*/React.createElement("div", {
      id: Styles.ctadisclaimer
    }, (() => {
      switch (browser) {
        case 'chrome':
          return /*#__PURE__*/React.createElement("p", null, "This free extension will update this browser's search engine to one powered by Yahoo!. By continuing, you acknowledge the ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank",
            className: Styles.bold
          }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank",
            className: Styles.bold
          }, "Privacy Policy"), ", and that you may be presented with more optional offers.");
          break;
        case 'firefox':
          return /*#__PURE__*/React.createElement("p", null, "This free extension will update this browser's search settings. By continuing, you acknowledge the ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank",
            className: Styles.bold
          }, "Privacy Policy"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank",
            className: Styles.bold
          }, "Terms of Service"), ", and that you may be presented with more optional offers.");
          break;
        default:
          return /*#__PURE__*/React.createElement("p", null, "By clicking Download, you agree to the ", /*#__PURE__*/React.createElement("a", {
            href: "/terms-of-service/",
            target: "_blank",
            className: Styles.bold
          }, "Terms of Service"), " and ", /*#__PURE__*/React.createElement("a", {
            href: "/privacy-policy/",
            target: "_blank",
            className: Styles.bold
          }, "Privacy Policy"), ".");
      }
    })());
  };
  return CtaDisclosure;
}(React.Component);
export default CtaDisclosure;